import React, { useContext, useEffect, useMemo, useState } from "react";
import { Typography, theme } from "antd";
import CheckListFBYInput from "../../../../../blocks/FormItems/CheckListFBYInput";
import {
  medicalTreatmentOptions,
  surgicalTreatmentOptions,
} from "../../../Options/historyOptions";
import { hexToRgba } from "../../../../../helpers/utility";

const { Text } = Typography;

const TreatmentHistory = ({ context, form }) => {
  const { token } = theme.useToken();
  const { formData } = useContext(context);
  const historyData = formData?.history || formData;

  const initialValues = useMemo(() => historyData, [historyData]);
  const [checkboxes, setCheckboxes] = useState([]);

  useEffect(() => {
    const initialCheckboxes = [
      ...medicalTreatmentOptions,
      ...surgicalTreatmentOptions,
    ].reduce((acc, checkbox) => {
      acc[checkbox.value] =
        initialValues?.treatment_history?.[checkbox.value] || false; // Initialize all checkboxes based on initialValues
      return acc;
    }, {});
    setCheckboxes(initialCheckboxes);
  }, [initialValues]);

  return (
    <>
      <Text>Treatment History</Text>
      <div
        className="subsection-card"
        style={{
          borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
          background: "transparent",
          marginTop: "8px",
        }}
      >
        <Text>Medical Treatment History</Text>
        <CheckListFBYInput
          options={medicalTreatmentOptions}
          checkboxes={checkboxes}
          setCheckboxes={setCheckboxes}
          keyChain={"treatment_history"}
          others_key={"medical_others"}
          form={form}
          field_key={["treatment_history", "medical_treatment_others"]}
        />
      </div>
      <div
        className="subsection-card"
        style={{
          borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
          background: "transparent",
          marginTop: "8px",
        }}
      >
        <Text level={5}>Surgical Treatment History</Text>
        <CheckListFBYInput
          options={surgicalTreatmentOptions}
          checkboxes={checkboxes}
          setCheckboxes={setCheckboxes}
          keyChain={"treatment_history"}
          others_key={"surgical_others"}
          form={form}
          field_key={["treatment_history", "surgical_treatment_others"]}
        />
      </div>
    </>
  );
};

export default TreatmentHistory;
